export interface BuildVncViewerUrlOptions {
  sessionId: string;
  ticket: string | null;
}

/** Build the same-origin noVNC viewer URL without putting credentials in the WS path. */
export function buildVncViewerUrl(options: BuildVncViewerUrlOptions): string {
  const encodedSessionId = encodeURIComponent(options.sessionId);
  const params = new URLSearchParams();
  if (options.ticket) params.set('t', options.ticket);
  const query = params.toString();
  return `/api/cowork/sessions/${encodedSessionId}/vnc-proxy/vnc.html${query ? `?${query}` : ''}`;
}

export function shouldReplaceVncBootstrap(
  currentInstance: string | null,
  nextInstance: string,
): boolean {
  return currentInstance === null || currentInstance !== nextInstance;
}
